module.exports = __webpack_public_path__ + "static/media/academic-smart.e7556d3a.svg";